import { z } from 'zod';
const checkInVolunteerParamsSchema = z.object({
    participationId: z.string().uuid(),
});
const checkInVolunteerResponseSchema = z.object({
    id: z.string().uuid(),
});
export const checkInVolunteerFunctionDef = {
    name: 'checkInVolunteer',
    requestSchema: checkInVolunteerParamsSchema,
    responseSchema: checkInVolunteerResponseSchema.optional(),
};
